// src/pages/Home/components/Navbar3/ui/HeaderIconButton.jsx

import React from "react";

import NotificationBadge from "./NotificationBadge";

import {
  cx,
} from "../utils/navbar3.utils";

export default function HeaderIconButton({
  label,
  onClick,
  children,
  count = 0,
  variant = "desktop",
  className = "",
}) {
  const isMobile =
    variant === "mobile";

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={cx(
        [
          "relative",
          "flex shrink-0",
          "items-center",
          "justify-center",
          "rounded-full",
          "text-white",
          "transition",
          "duration-200",
          "hover:bg-white/10",
          "active:scale-90",
          "focus-visible:outline-none",
          "focus-visible:ring-2",
          "focus-visible:ring-white/60",
        ].join(" "),
        isMobile
          ? "h-8 w-8"
          : "h-9 w-9",
        className,
      )}
    >
      {children}

      <NotificationBadge
        count={count}
        compact={isMobile}
      />
    </button>
  );
}